// extracted by mini-css-extract-plugin
export default {"content":"Dominances_content__LiEJO","title":"Dominances_title__nXjTx","text":"Dominances_text__enfJn"};